export default __webpack_public_path__ + "static/065-ac76c00f62f0dfc5cd22eb7a23caf212.jpg";